/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number ↔ Roman numeral`)
};

const es_rn_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número ↔ numeral romano`)
};

const de_rn_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahl ↔ Römische Zahl`)
};

const nl_rn_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getal ↔ Romeins getal`)
};

const fr_rn_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre ↔ Chiffre romain`)
};

const it_rn_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero ↔ Numerale romano`)
};

const pt_br2_rn_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número ↔ Numeral romano`)
};

const pt_rn_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número ↔ Numeral romano`)
};

const ja_rn_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字 ↔ ローマ数字`)
};

const zh_rn_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字 ↔ 罗马数字`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_nav_main_desc", locale)
	if (locale === "en") return en_rn_nav_main_desc(inputs)
	if (locale === "es") return es_rn_nav_main_desc(inputs)
	if (locale === "de") return de_rn_nav_main_desc(inputs)
	if (locale === "nl") return nl_rn_nav_main_desc(inputs)
	if (locale === "fr") return fr_rn_nav_main_desc(inputs)
	if (locale === "it") return it_rn_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_rn_nav_main_desc(inputs)
	if (locale === "pt") return pt_rn_nav_main_desc(inputs)
	if (locale === "ja") return ja_rn_nav_main_desc(inputs)
	return zh_rn_nav_main_desc(inputs)
};